import { render, staticRenderFns } from "./reservasInmediatas.vue?vue&type=template&id=07454684"
import script from "./reservasInmediatas.vue?vue&type=script&lang=js"
export * from "./reservasInmediatas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports